import { render, staticRenderFns } from "./PlayerPage.vue?vue&type=template&id=069ed3ea&scoped=true&"
import script from "./PlayerPage.vue?vue&type=script&lang=ts&"
export * from "./PlayerPage.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerPage.vue?vue&type=style&index=0&id=069ed3ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ed3ea",
  null
  
)

export default component.exports